import { render, staticRenderFns } from "./TheaterAdminPerformanceReport.vue?vue&type=template&id=3079a072&scoped=true"
import script from "./TheaterAdminPerformanceReport.vue?vue&type=script&lang=js"
export * from "./TheaterAdminPerformanceReport.vue?vue&type=script&lang=js"
import style0 from "./TheaterAdminPerformanceReport.vue?vue&type=style&index=0&id=3079a072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079a072",
  null
  
)

export default component.exports